import { render, staticRenderFns } from "./GridLegend.vue?vue&type=template&id=4f4b7a4e&"
import script from "./GridLegend.vue?vue&type=script&lang=js&"
export * from "./GridLegend.vue?vue&type=script&lang=js&"
import style0 from "./GridLegend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VContainer})
